export default "__VITE_ASSET__BtRa41G1__"